import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DesignAngularKitModule } from 'design-angular-kit';
import { RequestService } from '../../../../services/request.service';

@Component({
  selector: 'app-patient-refuse-modal',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule, FormsModule],
  templateUrl: './patient-refuse-modal.component.html',
  styleUrl: './patient-refuse-modal.component.scss',
})
export class PatientRefuseModalComponent {
  @Output() cancelled = new EventEmitter<void>();
  @Output() patientRefuse = new EventEmitter<{ note: string }>();

  note: string = '';
  type: number | null = null;
  causes: any[] = [];

  constructor(private requestService: RequestService) {}

  cancel(): void {
    this.cancelled.emit();
  }
  confirm() {
    const note = this.causes.find(c=> c.id == this.type).name + ' ' + this.note;
    this.patientRefuse.emit({ note: note});
  }

  ngOnInit() {
    this.requestService.getCauses('RP').subscribe(result => {
      this.causes = result;
    })
  }
}
